import { render, staticRenderFns } from "./proximos.vue?vue&type=template&id=5530518a&"
import script from "./proximos.vue?vue&type=script&lang=js&"
export * from "./proximos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports